<template>
  <div id="app">
    <NavBar/>
    <OurHistory/>
    <AboutUs/>
    <OurCooperation />
    <OurLocation/>
    <!-- <ContactForm/> -->
    <OurFooter/>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import OurHistory from './components/OurHistory.vue';
import AboutUs from './components/AboutUs.vue';
import OurCooperation from './components/OurCooperation.vue';
import OurLocation from './components/OurLocation.vue';
// import ContactForm from './components/ContactForm.vue'
import OurFooter from './components/OurFooter.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    OurHistory,
    AboutUs,
    OurCooperation,
    OurLocation,
    OurFooter,
    // ContactForm,
  }
}
</script>

<style>

@font-face {
  font-family: "Rubik";
  src: local("Inter"),
    url(./assets/fonts/Rubik-Regular.ttf) format("truetype");
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
